// extracted by mini-css-extract-plugin
export default {"outerContainer":"AppLabel_outerContainer__0O9OQ","labelBox":"AppLabel_labelBox__m9d8s","openLabel":"AppLabel_openLabel__10hga"};